import clsx from 'clsx';
import './BudgetRoundCheckbox.css';

export interface BudgetRoundCheckboxProps {
  checked: boolean;
  /** Вызывается только при interactive=true */
  onChange?: (next: boolean) => void;
  disabled?: boolean;
  /** false — только отображение (например в комбо без сохранения) */
  interactive?: boolean;
  title?: string;
  'aria-label'?: string;
}

/** Компактный круглый переключатель «учёт в бюджете» для ячеек таблицы */
export function BudgetRoundCheckbox({
  checked,
  onChange,
  disabled,
  interactive = true,
  title = 'Учёт в бюджете',
  'aria-label': ariaLabel,
}: BudgetRoundCheckboxProps) {
  const className = clsx('budget-round-checkbox', checked && 'budget-round-checkbox_checked');

  if (!interactive) {
    return (
      <span
        className={clsx(className, 'budget-round-checkbox_static')}
        title={title}
        aria-hidden
      />
    );
  }

  return (
    <button
      type="button"
      className={className}
      aria-pressed={checked}
      title={title}
      aria-label={ariaLabel ?? (checked ? 'Учитывается в бюджете' : 'Не учитывается в бюджете')}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange?.(!checked);
      }}
    />
  );
}
